"use client";

import { c as _c } from "react/compiler-runtime";
import { useLinkPreviewVariant } from "../LinkPreviewContext";
import { LinkPreviewCardLayout } from "../OpenGraphPreview";
import type { MarketplaceTypePreviewProps } from "./common";
import { getMarketplaceContainerClass, MARKETPLACE_MEDIA_FRAME_CLASS } from "./previewLayout";
export default function MarketplacePreviewPlaceholder(t0) {
  const $ = _c(15);
  const {
    href,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const variant = useLinkPreviewVariant();
  let t2;
  if ($[0] !== compact || $[1] !== variant) {
    t2 = getMarketplaceContainerClass(variant, compact);
    $[0] = compact;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${t2} tw-relative`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={`${MARKETPLACE_MEDIA_FRAME_CLASS} tw-relative tw-overflow-hidden`} data-testid="marketplace-preview-placeholder-media"><div className="tw-absolute tw-inset-0 tw-animate-pulse tw-bg-gradient-to-br tw-from-iron-900/60 tw-via-iron-800/40 tw-to-iron-900/60" /></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== compact) {
    t5 = !compact && <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-black/60 tw-px-3 tw-py-2.5" data-testid="marketplace-preview-placeholder-footer"><div className="tw-h-4 tw-w-28 tw-animate-pulse tw-rounded tw-bg-iron-700/50" /><div className="tw-flex tw-items-center tw-gap-2"><div className="tw-h-6 tw-w-16 tw-animate-pulse tw-rounded-full tw-bg-iron-700/50" /><div className="tw-size-8 tw-animate-pulse tw-rounded-full tw-bg-iron-700/50" /><div className="tw-size-8 tw-animate-pulse tw-rounded-full tw-bg-iron-700/50" /></div></div>;
    $[4] = compact;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="tw-flex tw-w-full tw-flex-col tw-overflow-hidden">{t4}{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className={t3} data-testid="marketplace-preview-placeholder">{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== href || $[12] !== t7 || $[13] !== variant) {
    t8 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t7}</LinkPreviewCardLayout>;
    $[11] = href;
    $[12] = t7;
    $[13] = variant;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}